import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import {
  mdiFolderHomeOutline,
  mdiHammerScrewdriver,
  mdiPencilOutline,
  mdiAccountHardHat,
} from "@mdi/js";
import { getGroupSkill } from "../../interpreter/groupSkill";
import "./AppDataTable.css";
import "./CategorieList.css";

export const CategorieList = ({ openModal, refresh }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    try {
      const response = await getGroupSkill();
      const categoriesData = response?.data?.getServiceCategory_?.category;
      if (!categoriesData || !Array.isArray(categoriesData)) {
        throw new Error("Datos de categorías no válidos");
      }

      const formattedData = categoriesData.map((cat) => ({
        id: cat.id ?? `temp-cat-${cat.name}`,
        name: cat.nameCategory || "Sin nombre",
        photo: cat.photo || null,
        subcategories: (cat.skill || []).map((skill) => ({
          id: skill.id_skill ?? `temp-skill-${skill.name}`,
          name: skill.name || "Habilidad sin nombre",
          photo: skill.photo || null,
        })),
      }));

      setCategories(formattedData);
    } catch (err) {
      setError(err.message);
      console.error("Error en fetchCategories:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [refresh]);

  if (loading) {
    return (
      <div className="table-loading">
        <div className="table-loading__spinner" role="status" aria-label="Cargando categorías" />
      </div>
    );
  }

  if (error) {
    return <div className="category-error">{error}</div>;
  }

  return (
    <div className="category-grid">
      {categories?.map((category) => (
        <article key={category.id} className="category-card">
          <button
            type="button"
            className="table-action table-action--labeled table-action--primary category-card__edit"
            title="Editar categoría"
            onClick={() => openModal("editCat", category)}
          >
            <Icon path={mdiPencilOutline} size={0.85} />
            <span className="table-action__label">Editar</span>
          </button>

          <div className="category-card__header">
            {category.photo ? (
              <img
                src={category.photo}
                alt={category.name}
                className="category-card__photo"
              />
            ) : (
              <Icon path={mdiFolderHomeOutline} size={2} className="category-card__icon" />
            )}
            <h3 className="category-card__title">{category.name}</h3>
          </div>

          <div>
            <div className="category-card__skills-header">
              <Icon path={mdiAccountHardHat} size={1.1} className="category-card__icon" />
              <h4 className="category-card__skills-title">Habilidades</h4>
              <button
                type="button"
                className="table-action table-action--labeled table-action--secondary"
                style={{ marginLeft: "auto" }}
                title="Editar habilidades"
                onClick={() => openModal("editHab", category)}
              >
                <Icon path={mdiHammerScrewdriver} size={0.85} />
                <span className="table-action__label">Gestionar</span>
              </button>
            </div>
            <ul className="category-card__skills-list">
              {category.subcategories?.map((sub) => (
                <li key={sub.id} className="category-card__skill-item">
                  {sub.photo && (
                    <img src={sub.photo} alt={sub.name} className="category-card__skill-photo" />
                  )}
                  <span>{sub.name}</span>
                </li>
              ))}
            </ul>
          </div>
        </article>
      ))}
    </div>
  );
};
